import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: `${theme.palette.background.default} !important`,
    marginTop: -22,
    marginLeft: -96,
    marginRight: -96,
    marginBottom: 56,
    [theme.breakpoints.down('sm')]: {
      marginRight: -14,
      marginLeft: -15
    }
  },
  header: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 12,
    [theme.breakpoints.down('sm')]: {
      columnGap: 15
    }
  },
  headerTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  formContainer: {
    display: 'grid',
    gridGap: 30,
    [theme.breakpoints.up('md')]: {
      gridTemplateColumns: '3fr 1fr'
    }
  },
  autoCompletesContainer: {},
  timePicker: {
    marginTop: 25
  },
  timePickerForMobile: {
    marginTop: 0
  },
  footer: {
    borderTop: `1px solid ${theme.palette.grey[400]}`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '10vh',
    height: '12vh',
    width: '100%'
  },
  appBar: {
    backgroundColor: `${theme.palette.background.default} !important`
  },
  contentContainer: {
    paddingRight: 72,
    paddingLeft: 72,
    paddingTop: 24,
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
      paddingLeft: 0
    }
  },
  circularProgress: {
    marginLeft: 8,
    color: theme.palette.primary.main
  }
}))

export default useStyles
